import { VpCategories } from './categories'

export const VpCarouselMethods = {
  vpCarouselComponentEnable: 'vpCarouselComponentEnable',
  vpCarouselEnable: 'vpCarouselEnable',
  vpCarouselPause: 'vpCarouselPause',
  vpCarouselContinue: 'vpCarouselContinue',
  vpCarouselRestart: 'vpCarouselRestart',
  vpCarouselDeleteResource: 'vpCarouselDeleteResource',
  vpCarouselSetStayTime: 'vpCarouselSetStayTime',
}

export const VpCarouselAstAction = {
  [VpCarouselMethods.vpCarouselComponentEnable]: {
    label: '启用/禁用轮播组件',
    category: VpCategories.carousel,
    paramFormConfig: {
      isEnable: {
        title: '启用/禁用',
        component: 'select',
        field: {
          options: [
            {
              label: '启用',
              value: true,
            },
            {
              label: '禁用',
              value: false,
            },
          ],
        },
      },
    },
  },
  [VpCarouselMethods.vpCarouselEnable]: {
    label: '启用/禁用轮播组',
    category: VpCategories.carousel,
    paramFormConfig: {
      carouselId: {
        title: '响应对象',
        component: 'select',
        field: {
          options: [],
        },
      },
      isEnable: {
        title: '启用/禁用',
        component: 'select',
        field: {
          options: [
            {
              label: '启用',
              value: true,
            },
            {
              label: '禁用',
              value: false,
            },
          ],
        },
      },
    },
  },
  [VpCarouselMethods.vpCarouselPause]: {
    label: '暂停/播放轮播组',
    category: VpCategories.carousel,
    paramFormConfig: {
      carouselId: {
        title: '响应对象',
        component: 'select',
        field: {
          options: [],
        },
      },
      isPause: {
        title: '暂停/播放',
        component: 'select',
        field: {
          options: [
            {
              label: '暂停',
              value: true,
            },
            {
              label: '播放',
              value: false,
            },
          ],
        },
      },
    },
  },
  [VpCarouselMethods.vpCarouselRestart]: {
    label: '重新轮播',
    category: VpCategories.carousel,
    paramFormConfig: {
      carouselId: {
        title: '响应对象',
        component: 'select',
        field: {
          options: [],
        },
      },
    },
  },
  [VpCarouselMethods.vpCarouselDeleteResource]: {
    label: '删除轮播资源',
    category: VpCategories.carousel,
    paramFormConfig: {
      resourceIds: {
        title: '响应对象',
        component: 'select-group',
        field: {
          options: [],
        },
      },
    },
  },
  [VpCarouselMethods.vpCarouselSetStayTime]: {
    label: '停留时间',
    category: VpCategories.carousel,
    paramFormConfig: {
      stayTime: {
        title: '停留时间',
        component: 'input',
      },
    },
  },
}
